<template>
  <div class="companyProfile text-left">
    <div class="flex-al-start flex-center flex-jc-ard">
      <div class="flex-55">
        <SpCard>
          <div>
            <p v-triangle class="cate-header font18">{{ $l('About Shiplus') }}</p>
            <p class="font18 italic-bold name-label">{{ $l('Registered Name') }}</p>
            <!--            {{ detail.name?.value }} -->
            <div class="gray-panel">Shiplus AI Platform (to be registered) </div>
            <!--            {{ detail.nativeName?.value }} -->
            <div class="gray-panel">船加AI平台（待注册）</div>
          </div>
          <div>
            <p class="font18 name-label">{{ $l('Profile') }}</p>
            <div class="profile" style="font-size: 16px; font-weight: 500; line-height: 24px">
              Shiplus is a trading/servicing platform that is focused to enable different parties to connect with each other, to trade directly, to reduce trading cost, time, and other wastes, to provide value added services, hence to improve overall experience in maritime non-containerized cargo transportation.
              <br><br>
              As we all know, this is a revolution in breaking the hundred-year-old tradition in negotiating a maritime non-containerized cargo transportation contract. It requires us to keep trying, keep improving, and keep renovating as a true artisan. More importantly, your true feeling and your feedback are critical to the improvement of Shiplus.
              <br><br>
              For this, we are sharing the following with you, all the valuable participants.
              <br><br>
              <span class="font-bold sp-color-1">Mission: </span> <span class="font-bold">direct connect, direct trading; and disintermediation, decentralization.</span>
              <br><br>
              <span class="font-bold sp-color-1">Vision: </span> <span class="font-bold">in about 2023, make “direct connect, direct trade” one of the most important trading platform.</span>
              <br><br>
              <span class="font-bold sp-color-1">Value: </span>
              <span class="font-bold">making maritime transportation and its related services simpler, more available, and more efficient using all kinds of technologies (IT/DT/AI/VR), and maximize artificial intelligent, and minimize human impact.</span>
              <br><br>
              <span class="font-bold sp-color-1">Plan: </span><span class="font-bold">2020-2023, target, from 0 to 1.</span>
              <br><br>
              In three years, direct connect the shipowners and charters in dry bulk chartering and break bulk chartering.
              <br><br>
              Keywords, focus, breakthrough.
            </div>
          </div>
        </SpCard>
      </div>

      <div class="flex-41">
        <div class="mg-t-40 pd-l-30 pd-t-10 sp-color-bg-4" style="min-height: 600px">
          <p class="">{{ $l('Some') }}</p>
          <el-image
            v-for="(img, index) in files"
            style="width: 221px; height: 281px; margin-right: 20px; border: 1px solid #CDCDCD; border-radius: 5px; margin-bottom: 20px"
            :src="img"
            :fit="index === 2 ? 'contain' : 'fill' "
            :preview-src-list="files.map(url => url)" :initial-index="index" />
          <!--          <el-image -->
          <!--            style="width: 221px; height: 281px" -->
          <!--            :src="url" -->
          <!--            :zoom-rate="1.2" -->
          <!--            :preview-src-list="srcList" -->
          <!--            :initial-index="4" -->
          <!--            fit="cover" -->
          <!--          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpCard from '@/components/common/SpCard'
import SpForm from '@/components/common/SpForm'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import { reactive } from 'vue'
import SpButton from '@/components/common/SpButton'
import {
  getEnterpriseOptionsCorpApi,
  getEnterpriseCorpDetailApi,
  editCorpIntroductionApi
} from '@/request/APIs/company'
import { computed, ref } from '@vue/runtime-core'
import SpMessage from '@/components/common/SpMessage'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import { getAboutUsApi } from '../../request/APIs/common'
export default {
  name: 'CompanyProfile',
  nameSpace: 'company.Profile',
  components: { SpUploadGroup, SpButton, SpSelectOption, SpSelect, SpInput, SpForm, SpCard },
  setup () {
    const files = ref([

    ])
    const url = require('../../../src/assets/crg.png')
    const profile = reactive({
      name: 'sss'
    })
    const detail = reactive({})
    // 提交公司简介
    const getAboutInfo = () => {
      getAboutUsApi().then(res => {
        Object.assign(detail, res.data)
      })
    }
    getAboutInfo()
    return {
      profile,
      files,
      detail
    }
  }
}
</script>

<style scoped lang="less">
.companyProfile{
  .gray-panel{
    background-color: #F6F6F6;
    padding: 0 24px;
    line-height: 52px;
    font-size: 16px;
    font-weight: 500;
  }
  .profile{
    background-color: #f6f6f6;
    padding: 16px 24px;
  }
  padding:@gap @gap 0 @gap;
  .name-label{
    font-weight: bold;
  }
}
</style>
